/* ============================================
   VAPOR MALL — Procedural Sprite Generator
   Generates pixel art sprites, tiles, and
   mall assets at runtime using canvas.
   ============================================ */

window.VaporSprites = (function () {
  const TILE = 32;
  const SPRITE_W = 16;
  const SPRITE_H = 24;

  // ---- Palette ----
  const PALETTE = {
    marble: ['#e8dfd0', '#d4c5b0', '#c9b99a', '#f0e8dc'],
    marbleDark: ['#b0a090', '#9a8a7a', '#8a7a6a'],
    marbleBlue: ['#c8d8e8', '#b0c4d8', '#a0b8d0', '#d0dce8'],
    neonPink: '#ff71ce',
    neonCyan: '#01cdfe',
    neonPurple: '#b967ff',
    neonGreen: '#05ffa1',
    neonYellow: '#fffb96',
    darkBg: '#1a1a2e',
    midBg: '#16213e',
    palmGreen: ['#0a6b3d', '#0d8a4e', '#10a85f'],
    palmTrunk: ['#8b6914', '#a07828'],
    fountain: ['#394867', '#4a6fa1'],
    water: ['#01cdfe', '#0196c4', '#016f93'],
    shopWall: '#2a1f3d',
    shopDoor: '#3a2f5d',
    glass: 'rgba(1, 205, 254, 0.15)',
    escalator: ['#555566', '#444455', '#666677'],
    railing: '#8888aa',
    bench: ['#5a4a3a', '#6b5b4b'],
    planter: ['#3a5a3a', '#2a4a2a'],
  };

  // ---- Helpers ----
  function createCanvas(w, h) {
    const c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    return c;
  }

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function drawPixel(ctx, x, y, color, scale) {
    scale = scale || 1;
    ctx.fillStyle = color;
    ctx.fillRect(x * scale, y * scale, scale, scale);
  }

  // ---- Tile generators ----

  function genMarbleFloor() {
    const c = createCanvas(TILE, TILE);
    const ctx = c.getContext('2d');
    ctx.fillStyle = PALETTE.marble[0];
    ctx.fillRect(0, 0, TILE, TILE);
    for (let i = 0; i < 40; i++) {
      ctx.fillStyle = pick(PALETTE.marble);
      const x = Math.random() * TILE | 0;
      const y = Math.random() * TILE | 0;
      ctx.fillRect(x, y, 1 + (Math.random() * 2 | 0), 1);
    }
    ctx.fillStyle = PALETTE.marbleDark[0];
    ctx.fillRect(0, 0, TILE, 1);
    ctx.fillRect(0, 0, 1, TILE);
    return c;
  }

  function genMarbleFloorBlue() {
    const c = createCanvas(TILE, TILE);
    const ctx = c.getContext('2d');
    ctx.fillStyle = PALETTE.marbleBlue[0];
    ctx.fillRect(0, 0, TILE, TILE);
    for (let i = 0; i < 40; i++) {
      ctx.fillStyle = pick(PALETTE.marbleBlue);
      const x = Math.random() * TILE | 0;
      const y = Math.random() * TILE | 0;
      ctx.fillRect(x, y, 1 + (Math.random() * 2 | 0), 1);
    }
    ctx.fillStyle = '#8a9aaa';
    ctx.fillRect(0, 0, TILE, 1);
    ctx.fillRect(0, 0, 1, TILE);
    return c;
  }

  function genCheckerFloor() {
    const c = createCanvas(TILE, TILE);
    const ctx = c.getContext('2d');
    const half = TILE / 2;
    ctx.fillStyle = '#e0d0e8';
    ctx.fillRect(0, 0, TILE, TILE);
    ctx.fillStyle = '#2a1f3d';
    ctx.fillRect(0, 0, half, half);
    ctx.fillStyle = '#2a1f3d';
    ctx.fillRect(half, half, half, half);
    ctx.fillStyle = 'rgba(255,255,255,0.03)';
    ctx.fillRect(0, 0, TILE, 1);
    ctx.fillRect(0, 0, 1, TILE);
    return c;
  }

  function genTerrazzoFloor() {
    var c = createCanvas(TILE, TILE);
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#d0c8c0';
    ctx.fillRect(0, 0, TILE, TILE);
    // Speckles — colorful chips
    var chipColors = ['#c85050', '#5080c8', '#50a060', '#d4a030', '#8060a0', '#e0d0b0', '#ffffff', '#303030'];
    for (var i = 0; i < 60; i++) {
      ctx.fillStyle = pick(chipColors);
      var cx = Math.random() * TILE | 0;
      var cy = Math.random() * TILE | 0;
      var cs = 1 + (Math.random() * 2 | 0);
      ctx.fillRect(cx, cy, cs, cs);
    }
    // Subtle grid
    ctx.fillStyle = 'rgba(0,0,0,0.05)';
    ctx.fillRect(0, 0, TILE, 1);
    ctx.fillRect(0, 0, 1, TILE);
    return c;
  }

  function genDarkGridFloor() {
    var c = createCanvas(TILE, TILE);
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#08080e';
    ctx.fillRect(0, 0, TILE, TILE);
    // Neon grid
    ctx.strokeStyle = 'rgba(1, 205, 254, 0.12)';
    ctx.lineWidth = 1;
    ctx.strokeRect(0, 0, TILE, TILE);
    // Cross in center
    ctx.strokeStyle = 'rgba(185, 103, 255, 0.08)';
    ctx.beginPath();
    ctx.moveTo(TILE / 2, 0); ctx.lineTo(TILE / 2, TILE);
    ctx.moveTo(0, TILE / 2); ctx.lineTo(TILE, TILE / 2);
    ctx.stroke();
    // Corner dots
    ctx.fillStyle = 'rgba(1, 205, 254, 0.15)';
    ctx.fillRect(0, 0, 2, 2);
    ctx.fillRect(TILE - 2, 0, 2, 2);
    ctx.fillRect(0, TILE - 2, 2, 2);
    ctx.fillRect(TILE - 2, TILE - 2, 2, 2);
    return c;
  }

  // Tile generator map — keyed by setting value
  var TILE_GENERATORS = {
    'marble-classic': genMarbleFloor,
    'checker-vaporwave': genCheckerFloor,
    'blue-marble': genMarbleFloorBlue,
    'terrazzo': genTerrazzoFloor,
    'dark-grid': genDarkGridFloor
  };

  function genFloorTile(style) {
    var gen = TILE_GENERATORS[style] || genMarbleFloor;
    return gen();
  }

  function genShopWall() {
    const c = createCanvas(TILE, TILE);
    const ctx = c.getContext('2d');
    ctx.fillStyle = PALETTE.shopWall;
    ctx.fillRect(0, 0, TILE, TILE);
    for (let row = 0; row < TILE; row += 8) {
      const offset = (row % 16 === 0) ? 0 : 8;
      for (let col = offset; col < TILE; col += 16) {
        ctx.strokeStyle = 'rgba(255,255,255,0.06)';
        ctx.strokeRect(col, row, 16, 8);
      }
    }
    return c;
  }

  function genShopWallGlass(tint) {
    const c = createCanvas(TILE, TILE);
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#0a0a1e';
    ctx.fillRect(0, 0, TILE, TILE);
    // Glass pane with colored tint
    ctx.fillStyle = tint || 'rgba(1, 205, 254, 0.12)';
    ctx.fillRect(2, 2, TILE - 4, TILE - 4);
    // Reflection streak
    ctx.fillStyle = 'rgba(255,255,255,0.08)';
    ctx.fillRect(4, 4, 3, TILE - 8);
    // Frame
    ctx.strokeStyle = 'rgba(255,255,255,0.1)';
    ctx.strokeRect(1, 1, TILE - 2, TILE - 2);
    return c;
  }

  function genShopDoor(color) {
    const c = createCanvas(TILE, TILE);
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#1a1a2e';
    ctx.fillRect(0, 0, TILE, TILE);
    ctx.fillStyle = PALETTE.shopDoor;
    ctx.fillRect(4, 2, TILE - 8, TILE - 2);
    ctx.fillStyle = PALETTE.glass;
    ctx.fillRect(6, 4, TILE - 12, TILE - 8);
    ctx.fillStyle = color || PALETTE.neonPink;
    ctx.fillRect(2, 0, TILE - 4, 2);
    // Glowing arrows
    ctx.fillStyle = color || PALETTE.neonPink;
    ctx.fillRect(12, 12, 2, 2);
    ctx.fillRect(14, 14, 2, 2);
    ctx.fillRect(16, 12, 2, 2);
    // Handle
    ctx.fillStyle = '#ccc';
    ctx.fillRect(TILE - 10, 14, 2, 4);
    return c;
  }

  function genEscalator(direction) {
    // Top-down 3D-ish escalator. 64×96px (2×3 tiles).
    // Two thick chrome rails flanking a belt of pseudo-3D steps with bevelled
    // edges. Glowing accent strips on the inner rails + top/bottom landings.
    const c = createCanvas(TILE * 2, TILE * 3);
    const ctx = c.getContext('2d');
    const w = TILE * 2;     // 64
    const h = TILE * 3;     // 96
    const isUp = direction === 'up';
    const accent = isUp ? '#05ffa1' : '#01cdfe';
    const accentDark = isUp ? '#02b070' : '#0188a8';

    // ---- Outer frame: dark drop shadow halo for separation from floor ----
    ctx.fillStyle = 'rgba(0,0,0,0.35)';
    ctx.fillRect(0, h - 2, w, 2);
    ctx.fillRect(w - 2, 0, 2, h);

    // ---- Side rails (chrome) ----
    const railW = 8;
    // Left rail body
    const lg = ctx.createLinearGradient(0, 0, railW, 0);
    lg.addColorStop(0, '#3a3a48');
    lg.addColorStop(0.4, '#7a7a8a');
    lg.addColorStop(0.7, '#a8a8b8');
    lg.addColorStop(1, '#5a5a6a');
    ctx.fillStyle = lg;
    ctx.fillRect(0, 0, railW, h);
    // Right rail body
    const rg = ctx.createLinearGradient(w - railW, 0, w, 0);
    rg.addColorStop(0, '#5a5a6a');
    rg.addColorStop(0.3, '#a8a8b8');
    rg.addColorStop(0.6, '#7a7a8a');
    rg.addColorStop(1, '#3a3a48');
    ctx.fillStyle = rg;
    ctx.fillRect(w - railW, 0, railW, h);
    // Bright top edges of each rail
    ctx.fillStyle = '#e0e0ee';
    ctx.fillRect(2, 0, 2, h);
    ctx.fillRect(w - 4, 0, 2, h);
    // Inner rail dark recess (where the belt meets the rail)
    ctx.fillStyle = '#1a1a26';
    ctx.fillRect(railW - 1, 0, 1, h);
    ctx.fillRect(w - railW, 0, 1, h);

    // ---- Belt area background ----
    const beltX = railW;
    const beltW = w - railW * 2;
    ctx.fillStyle = '#202028';
    ctx.fillRect(beltX, 0, beltW, h);

    // ---- Steps with bevelled edges (pseudo-3D) ----
    // Each step is 6px tall: 4px tread (light) + 2px riser shadow (dark).
    const stepH = 6;
    for (let y = 0; y < h; y += stepH) {
      // Tread top — slight gradient L→R for cylindrical feel
      const treadGrad = ctx.createLinearGradient(beltX, 0, beltX + beltW, 0);
      treadGrad.addColorStop(0, '#4a4a58');
      treadGrad.addColorStop(0.5, '#6a6a78');
      treadGrad.addColorStop(1, '#3a3a48');
      ctx.fillStyle = treadGrad;
      ctx.fillRect(beltX, y, beltW, 4);
      // Highlight: 1px lit edge on the leading side of the tread
      ctx.fillStyle = '#9a9aa8';
      ctx.fillRect(beltX, y, beltW, 1);
      // Riser shadow below tread
      ctx.fillStyle = '#0c0c14';
      ctx.fillRect(beltX, y + 4, beltW, 2);
      // Cleat groove down the center of the tread
      ctx.fillStyle = 'rgba(0,0,0,0.45)';
      ctx.fillRect(beltX + Math.floor(beltW / 2), y + 1, 1, 3);
    }

    // ---- Inner glowing handrail strips (the moving rubber rail) ----
    ctx.fillStyle = accent;
    ctx.shadowColor = accent;
    ctx.shadowBlur = 6;
    ctx.fillRect(railW - 2, 0, 1, h);
    ctx.fillRect(w - railW + 1, 0, 1, h);
    ctx.shadowBlur = 0;
    // Handrail tick marks (segmented pattern suggests motion)
    ctx.fillStyle = '#ffffff';
    for (let ty = isUp ? 0 : 4; ty < h; ty += 8) {
      ctx.fillRect(railW - 2, ty, 1, 2);
      ctx.fillRect(w - railW + 1, ty, 1, 2);
    }

    // ---- Top and bottom landing pads ----
    // Top landing — strip of solid metal with accent line
    ctx.fillStyle = '#5a5a68';
    ctx.fillRect(beltX, 0, beltW, 4);
    ctx.fillStyle = '#7a7a88';
    ctx.fillRect(beltX, 0, beltW, 1);
    ctx.fillStyle = accentDark;
    ctx.fillRect(beltX, 4, beltW, 1);
    // Bottom landing
    ctx.fillStyle = '#3a3a48';
    ctx.fillRect(beltX, h - 4, beltW, 4);
    ctx.fillStyle = '#1a1a26';
    ctx.fillRect(beltX, h - 1, beltW, 1);
    ctx.fillStyle = accentDark;
    ctx.fillRect(beltX, h - 5, beltW, 1);

    // ---- Direction arrows (3 stacked, brighter near the top of travel) ----
    const arrowYs = isUp ? [20, 44, 68] : [68, 44, 20];
    arrowYs.forEach(function (ay, idx) {
      const intensity = isUp ? 1 - idx * 0.25 : 1 - (2 - idx) * 0.25;
      const r = Math.round(parseInt(accent.substr(1, 2), 16) * intensity);
      const g = Math.round(parseInt(accent.substr(3, 2), 16) * intensity);
      const b = Math.round(parseInt(accent.substr(5, 2), 16) * intensity);
      const col = 'rgb(' + r + ',' + g + ',' + b + ')';
      ctx.fillStyle = col;
      ctx.shadowColor = accent;
      ctx.shadowBlur = 4;
      // Arrow chevron — pointing UP if isUp, DOWN otherwise
      if (isUp) {
        ctx.fillRect(w / 2 - 4, ay + 2, 9, 1);
        ctx.fillRect(w / 2 - 3, ay + 1, 7, 1);
        ctx.fillRect(w / 2 - 2, ay, 5, 1);
        ctx.fillRect(w / 2 - 1, ay - 1, 3, 1);
        ctx.fillRect(w / 2, ay - 2, 1, 1);
      } else {
        ctx.fillRect(w / 2, ay + 2, 1, 1);
        ctx.fillRect(w / 2 - 1, ay + 1, 3, 1);
        ctx.fillRect(w / 2 - 2, ay, 5, 1);
        ctx.fillRect(w / 2 - 3, ay - 1, 7, 1);
        ctx.fillRect(w / 2 - 4, ay - 2, 9, 1);
      }
      ctx.shadowBlur = 0;
    });

    // ---- Outer 1px dark border for crisp silhouette ----
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, w, 1);
    ctx.fillRect(0, h - 1, w, 1);
    ctx.fillRect(0, 0, 1, h);
    ctx.fillRect(w - 1, 0, 1, h);

    return c;
  }

  // ---- Sign Style Generators ----
  // Each returns a canvas. Called with (text, color).

  function genSign_neonBox(text, color) {
    var signW = TILE * 6;
    var signH = TILE * 1.5;
    var c = createCanvas(signW, signH);
    var ctx = c.getContext('2d');
    var col = color || PALETTE.neonPink;

    ctx.fillStyle = '#0a0a16';
    ctx.fillRect(0, 0, signW, signH);
    ctx.strokeStyle = col;
    ctx.lineWidth = 2;
    ctx.strokeRect(2, 2, signW - 4, signH - 4);
    ctx.strokeStyle = col + '44';
    ctx.lineWidth = 1;
    ctx.strokeRect(5, 5, signW - 10, signH - 10);

    ctx.font = '8px "Press Start 2P", monospace';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = col;
    ctx.shadowColor = col;
    ctx.shadowBlur = 16;
    ctx.fillText(text, signW / 2, signH / 2);
    ctx.shadowBlur = 8;
    ctx.fillText(text, signW / 2, signH / 2);
    ctx.shadowBlur = 0;
    ctx.fillText(text, signW / 2, signH / 2);
    return c;
  }

  function genSign_neonScript(text, color) {
    var signW = TILE * 6;
    var signH = TILE * 1.8;
    var c = createCanvas(signW, signH);
    var ctx = c.getContext('2d');
    var col = color || PALETTE.neonCyan;

    // Transparent backing — sign floats
    ctx.fillStyle = 'rgba(10,10,22,0.6)';
    ctx.fillRect(0, 0, signW, signH);

    // Cursive-ish effect: draw text with italic transform
    ctx.save();
    ctx.translate(signW / 2, signH / 2);
    ctx.rotate(-0.06);
    ctx.font = 'italic 9px "Press Start 2P", monospace';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    // Multi-pass glow
    ctx.shadowColor = col;
    ctx.shadowBlur = 20;
    ctx.fillStyle = col;
    ctx.fillText(text, 0, 0);
    ctx.shadowBlur = 10;
    ctx.fillText(text, 0, 0);
    ctx.shadowBlur = 4;
    ctx.fillStyle = '#fff';
    ctx.fillText(text, 0, 0);
    ctx.shadowBlur = 0;
    ctx.restore();

    // Underline swoosh
    ctx.strokeStyle = col;
    ctx.lineWidth = 1;
    ctx.shadowColor = col;
    ctx.shadowBlur = 6;
    ctx.beginPath();
    ctx.moveTo(signW * 0.15, signH * 0.72);
    ctx.quadraticCurveTo(signW * 0.5, signH * 0.78, signW * 0.85, signH * 0.68);
    ctx.stroke();
    ctx.shadowBlur = 0;
    return c;
  }

  function genSign_marquee(text, color) {
    var signW = TILE * 6;
    var signH = TILE * 1.8;
    var c = createCanvas(signW, signH);
    var ctx = c.getContext('2d');
    var col = color || PALETTE.neonPurple;

    // Dark backing
    ctx.fillStyle = '#0a0a16';
    ctx.fillRect(0, 0, signW, signH);

    // Marquee bulb border — dots around the edge
    var bulbSize = 3;
    var spacing = 8;
    ctx.fillStyle = col;
    // Top and bottom rows
    for (var bx = 4; bx < signW - 4; bx += spacing) {
      ctx.fillRect(bx, 3, bulbSize, bulbSize);
      ctx.fillRect(bx, signH - 3 - bulbSize, bulbSize, bulbSize);
    }
    // Left and right columns
    for (var by = 4; by < signH - 4; by += spacing) {
      ctx.fillRect(3, by, bulbSize, bulbSize);
      ctx.fillRect(signW - 3 - bulbSize, by, bulbSize, bulbSize);
    }

    // Glow behind bulbs
    ctx.shadowColor = col;
    ctx.shadowBlur = 4;
    for (var bx2 = 4; bx2 < signW - 4; bx2 += spacing) {
      ctx.fillRect(bx2, 3, bulbSize, bulbSize);
      ctx.fillRect(bx2, signH - 3 - bulbSize, bulbSize, bulbSize);
    }
    ctx.shadowBlur = 0;

    // Text
    ctx.font = '7px "Press Start 2P", monospace';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = '#fff';
    ctx.shadowColor = col;
    ctx.shadowBlur = 8;
    ctx.fillText(text, signW / 2, signH / 2);
    ctx.shadowBlur = 0;
    ctx.fillText(text, signW / 2, signH / 2);
    return c;
  }

  function genSign_minimal(text, color) {
    var signW = TILE * 6;
    var signH = TILE * 1.2;
    var c = createCanvas(signW, signH);
    var ctx = c.getContext('2d');
    var col = color || PALETTE.neonGreen;

    // Transparent backing
    ctx.fillStyle = 'rgba(10,10,22,0.4)';
    ctx.fillRect(0, 0, signW, signH);

    // Single thin line top
    ctx.fillStyle = col;
    ctx.fillRect(signW * 0.1, 2, signW * 0.8, 1);

    // Text — clean, no heavy glow
    ctx.font = '7px "Press Start 2P", monospace';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = col;
    ctx.shadowColor = col;
    ctx.shadowBlur = 4;
    ctx.fillText(text, signW / 2, signH / 2);
    ctx.shadowBlur = 0;
    ctx.fillText(text, signW / 2, signH / 2);

    // Single thin line bottom
    ctx.fillStyle = col;
    ctx.fillRect(signW * 0.1, signH - 3, signW * 0.8, 1);
    return c;
  }

  var SIGN_GENERATORS = {
    'neon-box': genSign_neonBox,
    'neon-script': genSign_neonScript,
    'marquee': genSign_marquee,
    'minimal': genSign_minimal
  };

  function genSign(text, color, style) {
    var gen = SIGN_GENERATORS[style] || genSign_neonBox;
    return gen(text, color);
  }

  // ---- Store Front Style Generators ----
  // Each returns a canvas tile for the store front wall.

  function genStoreFront_glassModern(tint) {
    var c = createCanvas(TILE, TILE);
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#0a0a1e';
    ctx.fillRect(0, 0, TILE, TILE);
    ctx.fillStyle = tint || 'rgba(1, 205, 254, 0.12)';
    ctx.fillRect(2, 2, TILE - 4, TILE - 4);
    ctx.fillStyle = 'rgba(255,255,255,0.08)';
    ctx.fillRect(4, 4, 3, TILE - 8);
    ctx.strokeStyle = 'rgba(255,255,255,0.1)';
    ctx.strokeRect(1, 1, TILE - 2, TILE - 2);
    return c;
  }

  function genStoreFront_brickVintage(tint) {
    var c = createCanvas(TILE, TILE);
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#3a2020';
    ctx.fillRect(0, 0, TILE, TILE);
    // Brick pattern
    for (var row = 0; row < TILE; row += 6) {
      var offset = (row % 12 === 0) ? 0 : 7;
      for (var col = offset; col < TILE; col += 14) {
        ctx.fillStyle = pick(['#4a2828', '#3e2222', '#452525']);
        ctx.fillRect(col + 1, row + 1, 12, 4);
      }
      ctx.fillStyle = 'rgba(0,0,0,0.15)';
      ctx.fillRect(0, row, TILE, 1);
    }
    // Subtle color tint
    if (tint) {
      ctx.fillStyle = tint;
      ctx.fillRect(0, 0, TILE, TILE);
    }
    return c;
  }

  function genStoreFront_marbleLuxury(tint) {
    var c = createCanvas(TILE, TILE);
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#d8d0c0';
    ctx.fillRect(0, 0, TILE, TILE);
    // Marble veins
    for (var i = 0; i < 30; i++) {
      ctx.fillStyle = pick(['#c8c0b0', '#b8b0a0', '#e0d8c8']);
      ctx.fillRect(Math.random() * TILE | 0, Math.random() * TILE | 0, 1 + (Math.random() * 3 | 0), 1);
    }
    // Gold trim lines
    ctx.fillStyle = 'rgba(212, 175, 55, 0.2)';
    ctx.fillRect(0, 0, TILE, 2);
    ctx.fillRect(0, TILE - 2, TILE, 2);
    // Darken for depth
    ctx.fillStyle = 'rgba(0,0,0,0.4)';
    ctx.fillRect(0, 0, TILE, TILE);
    if (tint) {
      ctx.fillStyle = tint;
      ctx.fillRect(0, 0, TILE, TILE);
    }
    return c;
  }

  function genStoreFront_cyberGrid(tint) {
    var c = createCanvas(TILE, TILE);
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#08080e';
    ctx.fillRect(0, 0, TILE, TILE);
    // Grid lines
    ctx.strokeStyle = 'rgba(1, 205, 254, 0.15)';
    ctx.lineWidth = 1;
    for (var gx = 0; gx < TILE; gx += 8) {
      ctx.beginPath();
      ctx.moveTo(gx, 0);
      ctx.lineTo(gx, TILE);
      ctx.stroke();
    }
    for (var gy = 0; gy < TILE; gy += 8) {
      ctx.beginPath();
      ctx.moveTo(0, gy);
      ctx.lineTo(TILE, gy);
      ctx.stroke();
    }
    // Random glowing pixel nodes
    for (var n = 0; n < 4; n++) {
      ctx.fillStyle = pick(['rgba(1,205,254,0.3)', 'rgba(185,103,255,0.3)', 'rgba(255,113,206,0.3)']);
      var nx = (Math.floor(Math.random() * 4)) * 8;
      var ny = (Math.floor(Math.random() * 4)) * 8;
      ctx.fillRect(nx + 3, ny + 3, 2, 2);
    }
    if (tint) {
      ctx.fillStyle = tint;
      ctx.fillRect(0, 0, TILE, TILE);
    }
    return c;
  }

  var STOREFRONT_GENERATORS = {
    'glass-modern': genStoreFront_glassModern,
    'brick-vintage': genStoreFront_brickVintage,
    'marble-luxury': genStoreFront_marbleLuxury,
    'cyber-grid': genStoreFront_cyberGrid
  };

  function genStoreFront(style, tint) {
    var gen = STOREFRONT_GENERATORS[style] || genStoreFront_glassModern;
    return gen(tint);
  }

  function genPalmTree() {
    const c = createCanvas(TILE * 2, TILE * 3);
    const ctx = c.getContext('2d');
    const cx = TILE;
    for (let y = TILE; y < TILE * 3; y += 2) {
      ctx.fillStyle = pick(PALETTE.palmTrunk);
      ctx.fillRect(cx - 2, y, 4, 2);
    }
    const greens = PALETTE.palmGreen;
    const fronds = [
      [-14, -4], [-10, -8], [-4, -10], [4, -10], [10, -8], [14, -4],
      [-12, -2], [12, -2], [-6, -12], [6, -12]
    ];
    fronds.forEach(function(f) {
      ctx.fillStyle = pick(greens);
      ctx.beginPath();
      ctx.ellipse(cx + f[0], TILE + f[1], 6, 3, Math.atan2(f[1], f[0]), 0, Math.PI * 2);
      ctx.fill();
    });
    return c;
  }

  function genFountain() {
    const size = TILE * 3;
    const c = createCanvas(size, size);
    const ctx = c.getContext('2d');
    const cx = size / 2;
    const cy = size / 2;
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.beginPath();
    ctx.ellipse(cx + 2, cy + 14, 42, 22, 0, 0, Math.PI * 2);
    ctx.fill();
    // Base
    ctx.fillStyle = PALETTE.fountain[0];
    ctx.beginPath();
    ctx.ellipse(cx, cy + 10, 40, 20, 0, 0, Math.PI * 2);
    ctx.fill();
    // Water
    ctx.fillStyle = PALETTE.water[0];
    ctx.beginPath();
    ctx.ellipse(cx, cy + 10, 35, 16, 0, 0, Math.PI * 2);
    ctx.fill();
    // Water sparkle
    ctx.fillStyle = 'rgba(255,255,255,0.3)';
    ctx.fillRect(cx - 10, cy + 6, 3, 1);
    ctx.fillRect(cx + 8, cy + 12, 2, 1);
    ctx.fillRect(cx - 2, cy + 4, 2, 1);
    // Inner rim
    ctx.fillStyle = PALETTE.fountain[1];
    ctx.beginPath();
    ctx.ellipse(cx, cy, 16, 10, 0, 0, Math.PI * 2);
    ctx.fill();
    // Inner water
    ctx.fillStyle = PALETTE.water[1];
    ctx.beginPath();
    ctx.ellipse(cx, cy, 12, 7, 0, 0, Math.PI * 2);
    ctx.fill();
    // Center spout
    ctx.fillStyle = PALETTE.fountain[1];
    ctx.fillRect(cx - 2, cy - 20, 4, 20);
    // Water spray particles
    ctx.fillStyle = PALETTE.water[0];
    ctx.globalAlpha = 0.6;
    [-8, -4, 0, 4, 8].forEach(function(ox) {
      ctx.fillRect(cx + ox, cy - 22 + Math.abs(ox), 2, 2);
    });
    ctx.globalAlpha = 1;
    return c;
  }

  function genBench() {
    const c = createCanvas(TILE * 2, TILE);
    const ctx = c.getContext('2d');
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.fillRect(6, TILE - 6, TILE * 2 - 12, 6);
    // Legs
    ctx.fillStyle = PALETTE.bench[1];
    ctx.fillRect(8, 16, 4, 14);
    ctx.fillRect(TILE * 2 - 12, 16, 4, 14);
    // Seat
    ctx.fillStyle = PALETTE.bench[0];
    ctx.fillRect(4, 12, TILE * 2 - 8, 6);
    // Back
    ctx.fillStyle = PALETTE.bench[1];
    ctx.fillRect(4, 4, TILE * 2 - 8, 10);
    ctx.fillStyle = PALETTE.bench[0];
    ctx.fillRect(6, 6, TILE * 2 - 12, 6);
    return c;
  }

  function genPlanter() {
    const c = createCanvas(TILE, TILE * 2);
    const ctx = c.getContext('2d');
    // Pot shadow
    ctx.fillStyle = 'rgba(0,0,0,0.1)';
    ctx.beginPath();
    ctx.ellipse(TILE / 2 + 2, TILE * 2 - 4, 14, 6, 0, 0, Math.PI * 2);
    ctx.fill();
    // Pot
    ctx.fillStyle = '#8a6a5a';
    ctx.fillRect(6, TILE, TILE - 12, TILE - 4);
    ctx.fillStyle = '#9a7a6a';
    ctx.fillRect(4, TILE - 2, TILE - 8, 4);
    // Soil
    ctx.fillStyle = '#3a2a1a';
    ctx.fillRect(8, TILE, TILE - 16, 4);
    // Plant
    var greens = PALETTE.palmGreen;
    for (var i = 0; i < 6; i++) {
      ctx.fillStyle = pick(greens);
      ctx.beginPath();
      ctx.ellipse(
        TILE / 2 + (Math.random() - 0.5) * 12,
        TILE - 6 - Math.random() * 16,
        5 + Math.random() * 4,
        3 + Math.random() * 3,
        Math.random() * Math.PI,
        0, Math.PI * 2
      );
      ctx.fill();
    }
    return c;
  }

  // ---- Player sprite generator ----
  // Shade a hex color by a factor: factor < 1 darkens, > 1 lightens.
  function shade(hex, factor) {
    var h = hex.replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    var r = parseInt(h.substr(0, 2), 16);
    var g = parseInt(h.substr(2, 2), 16);
    var b = parseInt(h.substr(4, 2), 16);
    r = Math.max(0, Math.min(255, Math.round(r * factor)));
    g = Math.max(0, Math.min(255, Math.round(g * factor)));
    b = Math.max(0, Math.min(255, Math.round(b * factor)));
    return '#' + [r, g, b].map(function (v) { return v.toString(16).padStart(2, '0'); }).join('');
  }

  function genPlayerSprite(options) {
    var opt = Object.assign({
      skin: '#f5c6a0',
      shirt: '#ff71ce',
      pants: '#2a1f3d',
      hair: '#1a1a2e',
      hairStyle: 0
    }, options);

    // Precomputed shades for depth
    var skinShade = shade(opt.skin, 0.82);
    var skinLight = shade(opt.skin, 1.08);
    var shirtShade = shade(opt.shirt, 0.78);
    var shirtLight = shade(opt.shirt, 1.15);
    var pantsShade = shade(opt.pants, 0.72);
    var pantsLight = shade(opt.pants, 1.25);
    var hairShade = shade(opt.hair, 0.7);
    var hairLight = shade(opt.hair, 1.4);

    var FRAMES = 4;
    var DIRS = 4;
    var SCALE = 2;
    var SW = SPRITE_W * SCALE;
    var SH = SPRITE_H * SCALE;
    var c = createCanvas(SW * FRAMES, SH * DIRS);
    var ctx = c.getContext('2d');

    // Big pixel — fills one 16×24 grid cell (SCALE × SCALE output px)
    function px(x, y, color) {
      drawPixel(ctx, x, y, color, SCALE);
    }
    // Sub-pixel — targets one quadrant of a big pixel (1×1 output px).
    // qx/qy ∈ {0, 1}: 0 = left/top half, 1 = right/bottom half
    function sub(x, y, qx, qy, color) {
      ctx.fillStyle = color;
      ctx.fillRect(x * SCALE + qx, y * SCALE + qy, 1, 1);
    }
    // Horizontal sub-pixel line across a big pixel row (2 px wide)
    function subRow(x, y, qy, color) {
      ctx.fillStyle = color;
      ctx.fillRect(x * SCALE, y * SCALE + qy, SCALE, 1);
    }

    for (var dir = 0; dir < DIRS; dir++) {
      for (var frame = 0; frame < FRAMES; frame++) {
        var ox = frame * SPRITE_W;
        var oy = dir * SPRITE_H;
        var walk = frame % 2 === 1;

        ctx.save();
        ctx.translate(ox * SCALE, oy * SCALE);

        // ---- Contact shadow (soft, elliptical) ----
        ctx.fillStyle = 'rgba(0,0,0,0.28)';
        ctx.beginPath();
        ctx.ellipse(8 * SCALE, 22.4 * SCALE, 4.6 * SCALE, 1.5 * SCALE, 0, 0, Math.PI * 2);
        ctx.fill();

        // ---- Legs (with pants shading + seam highlight) ----
        var legSpread = walk ? 1 : 0;
        var leftLift = walk && frame === 1 ? -1 : 0;
        var rightLift = walk && frame === 3 ? -1 : 0;
        // Left leg
        px(5 - legSpread, 19 + leftLift, opt.pants);
        px(6 - legSpread, 19 + leftLift, opt.pants);
        px(5 - legSpread, 20, opt.pants);
        px(6 - legSpread, 20, opt.pants);
        // Right leg
        px(9 + legSpread, 19 + rightLift, opt.pants);
        px(10 + legSpread, 19 + rightLift, opt.pants);
        px(9 + legSpread, 20, opt.pants);
        px(10 + legSpread, 20, opt.pants);
        // Pants shading (outer sides darker)
        subRow(5 - legSpread, 19 + leftLift, 0, pantsShade);
        subRow(10 + legSpread, 19 + rightLift, 1, pantsLight);
        // Inner seam highlight
        sub(6 - legSpread, 19 + leftLift, 1, 0, pantsLight);
        sub(9 + legSpread, 19 + rightLift, 0, 0, pantsLight);

        // ---- Shoes (with darker sole) ----
        px(5 - legSpread, 21, '#222');
        px(6 - legSpread, 21, '#222');
        px(9 + legSpread, 21, '#222');
        px(10 + legSpread, 21, '#222');
        // Sole (bottom half darker)
        subRow(5 - legSpread, 21, 1, '#000');
        subRow(6 - legSpread, 21, 1, '#000');
        subRow(9 + legSpread, 21, 1, '#000');
        subRow(10 + legSpread, 21, 1, '#000');
        // Shoe highlight (top front catches light)
        sub(5 - legSpread, 21, 0, 0, '#444');
        sub(9 + legSpread, 21, 0, 0, '#444');

        // ---- Torso ----
        for (var ty = 13; ty <= 18; ty++) {
          for (var tx = 5; tx <= 10; tx++) {
            px(tx, ty, opt.shirt);
          }
        }
        // Torso side shading (darker on left edge, lighter on right for a lit-from-right look)
        for (var sy = 13; sy <= 18; sy++) {
          subRow(5, sy, 0, shirtShade);
          subRow(10, sy, 1, shirtLight);
        }
        // Collar / neck hole (front-facing dirs)
        if (dir === 0 || dir === 3) {
          sub(7, 13, 1, 0, shirtShade);
          sub(8, 13, 0, 0, shirtShade);
          // Neck shadow on skin above
          sub(7, 12, 1, 1, skinShade);
          sub(8, 12, 0, 1, skinShade);
        }
        // Belt line
        for (var bx = 5; bx <= 10; bx++) subRow(bx, 18, 1, shirtShade);

        // ---- Arms (with sleeves & skin highlights) ----
        var armBob = walk ? (frame === 1 ? -1 : frame === 3 ? 1 : 0) : 0;
        // Left arm
        px(3, 14 + armBob, opt.shirt);
        px(4, 14 + armBob, opt.shirt);
        px(3, 15 + armBob, opt.skin);
        subRow(3, 14 + armBob, 0, shirtShade); // outer shoulder shadow
        subRow(3, 15 + armBob, 0, skinShade);  // outer hand edge
        // Right arm
        px(11, 14 - armBob, opt.shirt);
        px(12, 14 - armBob, opt.shirt);
        px(12, 15 - armBob, opt.skin);
        subRow(12, 14 - armBob, 1, shirtLight); // lit outer shoulder
        subRow(12, 15 - armBob, 1, skinLight);  // lit hand edge

        // ---- Head (rounded corners — cut top corners to skin-shade for subtle round) ----
        for (var hy = 5; hy <= 11; hy++) {
          for (var hx = 4; hx <= 11; hx++) {
            px(hx, hy, opt.skin);
          }
        }
        px(7, 12, opt.skin); // chin
        px(8, 12, opt.skin);
        // Round the head top corners (erase tiny sub-pixels)
        ctx.clearRect(4 * SCALE, 5 * SCALE, 1, 1);
        ctx.clearRect(11 * SCALE + 1, 5 * SCALE, 1, 1);
        // Face shading (side away from light)
        for (var fy = 5; fy <= 11; fy++) subRow(4, fy, 0, skinShade);
        // Face highlight (lit side)
        for (var fy2 = 5; fy2 <= 11; fy2++) subRow(11, fy2, 1, skinLight);
        // Cheek blush (subtle warm tone)
        sub(5, 10, 0, 1, shade(opt.skin, 0.92));
        sub(10, 10, 1, 1, shade(opt.skin, 0.92));
        // Jaw shadow
        sub(7, 12, 0, 1, skinShade);
        sub(8, 12, 1, 1, skinShade);

        // ---- Eyes + face (with whites, pupils, brows, nose) ----
        if (dir === 0) {
          // Left eye — white base + dark pupil inside
          px(5, 8, '#fff');
          sub(5, 8, 0, 0, skinShade);      // outer corner dim
          sub(5, 8, 1, 0, '#111');          // pupil top-right
          sub(5, 8, 1, 1, '#111');          // pupil bottom-right
          // Right eye
          px(10, 8, '#fff');
          sub(10, 8, 1, 0, skinShade);
          sub(10, 8, 0, 0, '#111');
          sub(10, 8, 0, 1, '#111');
          // Eyebrows
          sub(5, 7, 0, 1, hairShade);
          sub(5, 7, 1, 1, hairShade);
          sub(10, 7, 0, 1, hairShade);
          sub(10, 7, 1, 1, hairShade);
          // Nose (tiny sub-pixel)
          sub(7, 10, 1, 1, skinShade);
          sub(8, 10, 0, 1, skinShade);
        } else if (dir === 1) {
          // Left profile — single visible eye
          px(4, 8, '#fff');
          sub(4, 8, 1, 0, '#111');
          sub(4, 8, 1, 1, '#111');
          sub(4, 7, 0, 1, hairShade); sub(4, 7, 1, 1, hairShade); // brow
          // Nose silhouette (pokes out on left)
          sub(3, 9, 1, 1, skinShade);
          sub(3, 10, 1, 0, skinShade);
        } else if (dir === 2) {
          // Right profile
          px(11, 8, '#fff');
          sub(11, 8, 0, 0, '#111');
          sub(11, 8, 0, 1, '#111');
          sub(11, 7, 0, 1, hairShade); sub(11, 7, 1, 1, hairShade);
          sub(12, 9, 0, 1, skinShade);
          sub(12, 10, 0, 0, skinShade);
        }
        // dir === 3 (up): back of head, no face — hair covers it below

        // ---- Hair (with highlight strand on lit side) ----
        if (opt.hairStyle === 0) {
          // Short / flat top
          for (var hx2 = 3; hx2 <= 12; hx2++) { px(hx2, 4, opt.hair); px(hx2, 5, opt.hair); }
          px(3, 6, opt.hair); px(12, 6, opt.hair);
          // Highlight strand on right side (lit)
          for (var hsx = 8; hsx <= 11; hsx++) subRow(hsx, 4, 0, hairLight);
          // Shadow under hairline on face
          for (var hsh = 4; hsh <= 11; hsh++) subRow(hsh, 6, 0, hairShade);
        } else if (opt.hairStyle === 1) {
          // Long
          for (var hx3 = 3; hx3 <= 12; hx3++) { px(hx3, 3, opt.hair); px(hx3, 4, opt.hair); px(hx3, 5, opt.hair); }
          px(3, 6, opt.hair); px(3, 7, opt.hair); px(3, 8, opt.hair);
          px(12, 6, opt.hair); px(12, 7, opt.hair); px(12, 8, opt.hair);
          if (dir === 0 || dir === 3) { px(3, 9, opt.hair); px(12, 9, opt.hair); }
          // Top highlight sheen
          for (var lhs = 6; lhs <= 10; lhs++) subRow(lhs, 3, 0, hairLight);
          // Strand shadows (texture)
          sub(5, 4, 0, 1, hairShade); sub(7, 4, 1, 1, hairShade); sub(9, 4, 0, 1, hairShade);
          // Side darker edges
          subRow(12, 6, 1, hairShade); subRow(12, 7, 1, hairShade); subRow(12, 8, 1, hairShade);
        } else if (opt.hairStyle === 2) {
          // Spiky
          for (var hx4 = 3; hx4 <= 12; hx4++) { px(hx4, 4, opt.hair); }
          px(4, 2, opt.hair); px(6, 1, opt.hair); px(8, 2, opt.hair);
          px(10, 1, opt.hair); px(12, 3, opt.hair); px(3, 3, opt.hair);
          px(5, 3, opt.hair); px(7, 2, opt.hair); px(9, 3, opt.hair); px(11, 2, opt.hair);
          // Spike tip highlights
          sub(6, 1, 0, 0, hairLight); sub(10, 1, 0, 0, hairLight);
          sub(4, 2, 1, 0, hairLight); sub(8, 2, 1, 0, hairLight);
          // Hairline shadow
          for (var ss = 3; ss <= 12; ss++) subRow(ss, 4, 1, hairShade);
        }

        ctx.restore();
      }
    }
    return c;
  }

  // ---- Generate all textures and add to Phaser ----
  function loadIntoPhaser(scene) {
    // Generate all tile variants
    Object.keys(TILE_GENERATORS).forEach(function(key) {
      scene.textures.addCanvas('tile-' + key, TILE_GENERATORS[key]());
    });

    scene.textures.addCanvas('tile-wall', genShopWall());
    scene.textures.addCanvas('palm', genPalmTree());
    scene.textures.addCanvas('fountain', genFountain());
    scene.textures.addCanvas('bench', genBench());
    scene.textures.addCanvas('planter', genPlanter());
    scene.textures.addCanvas('escalator-up', genEscalator('up'));
    scene.textures.addCanvas('escalator-down', genEscalator('down'));

    // Generate store-specific textures per floor
    var floors = window.VAPOR_MALL.floors || [];
    var globalStoreIdx = 0;
    floors.forEach(function(floor) {
      (floor.stores || []).forEach(function(store) {
        var col = store.signPulseColor || PALETTE.neonPink;
        var name = store.name || ('SHOP ' + (globalStoreIdx + 1));
        var key = 'f' + floor.floor + '-' + store.position;

        scene.textures.addCanvas('sign-' + key, genSign(name, col, store.signStyle));
        scene.textures.addCanvas('door-' + key, genShopDoor(col));
        scene.textures.addCanvas('storefront-' + key, genStoreFront(store.storeStyle, col + '10'));
        globalStoreIdx++;
      });
    });

    scene.textures.addCanvas('player-default', genPlayerSprite({}));
  }

  // ---- Roman Grotto Background for Shop Interior ----
  function genGrottoBackground(width, height) {
    var c = createCanvas(width, height);
    var ctx = c.getContext('2d');
    var w = width;
    var h = height;

    // Sky / ceiling gradient — deep vaporwave
    var skyGrad = ctx.createLinearGradient(0, 0, 0, h * 0.3);
    skyGrad.addColorStop(0, '#0a0a1e');
    skyGrad.addColorStop(1, '#1a1a3e');
    ctx.fillStyle = skyGrad;
    ctx.fillRect(0, 0, w, h * 0.3);

    // Back wall — dark marble
    var wallGrad = ctx.createLinearGradient(0, h * 0.15, 0, h);
    wallGrad.addColorStop(0, '#1a1a2e');
    wallGrad.addColorStop(0.5, '#12122a');
    wallGrad.addColorStop(1, '#0a0a1a');
    ctx.fillStyle = wallGrad;
    ctx.fillRect(0, h * 0.15, w, h * 0.85);

    // Marble texture on walls
    ctx.globalAlpha = 0.03;
    for (var i = 0; i < 800; i++) {
      ctx.fillStyle = pick(['#e8dfd0', '#d4c5b0', '#c9b99a', '#8888aa']);
      var mx = Math.random() * w;
      var my = h * 0.15 + Math.random() * h * 0.85;
      ctx.fillRect(mx, my, 1 + Math.random() * 3, 1);
    }
    ctx.globalAlpha = 1;

    // Floor — reflective marble
    var floorY = h * 0.72;
    var floorGrad = ctx.createLinearGradient(0, floorY, 0, h);
    floorGrad.addColorStop(0, '#2a2040');
    floorGrad.addColorStop(0.3, '#1a1830');
    floorGrad.addColorStop(1, '#0a0a16');
    ctx.fillStyle = floorGrad;
    ctx.fillRect(0, floorY, w, h - floorY);

    // Floor tile grid
    ctx.strokeStyle = 'rgba(255,255,255,0.03)';
    ctx.lineWidth = 1;
    for (var fx = 0; fx < w; fx += 40) {
      ctx.beginPath();
      ctx.moveTo(fx, floorY);
      ctx.lineTo(fx, h);
      ctx.stroke();
    }
    for (var fy = floorY; fy < h; fy += 20) {
      ctx.beginPath();
      ctx.moveTo(0, fy);
      ctx.lineTo(w, fy);
      ctx.stroke();
    }

    // Water channel across the floor
    var waterY = floorY + (h - floorY) * 0.4;
    ctx.fillStyle = 'rgba(1, 205, 254, 0.08)';
    ctx.fillRect(0, waterY - 8, w, 16);
    ctx.fillStyle = 'rgba(1, 205, 254, 0.15)';
    ctx.fillRect(0, waterY - 2, w, 4);
    // Water sparkles
    ctx.fillStyle = 'rgba(255,255,255,0.2)';
    for (var ws = 0; ws < 20; ws++) {
      ctx.fillRect(Math.random() * w, waterY - 4 + Math.random() * 8, 2, 1);
    }

    // ---- Arches ----
    var archCount = 5;
    var archSpacing = w / (archCount + 1);
    for (var ai = 1; ai <= archCount; ai++) {
      var ax = ai * archSpacing;
      var archTop = h * 0.12;
      var archBottom = floorY;
      var archW = archSpacing * 0.55;
      var archH = archBottom - archTop;

      // Column left
      _drawColumn(ctx, ax - archW / 2 - 8, archTop, archBottom);
      // Column right
      _drawColumn(ctx, ax + archW / 2 - 4, archTop, archBottom);

      // Arch curve
      ctx.strokeStyle = 'rgba(200, 190, 180, 0.15)';
      ctx.lineWidth = 6;
      ctx.beginPath();
      ctx.arc(ax, archTop + archH * 0.35, archW / 2, Math.PI, 0);
      ctx.stroke();

      // Inner arch glow
      ctx.strokeStyle = 'rgba(185, 103, 255, 0.06)';
      ctx.lineWidth = 12;
      ctx.beginPath();
      ctx.arc(ax, archTop + archH * 0.35, archW / 2 - 6, Math.PI, 0);
      ctx.stroke();
    }

    // ---- Statues (2 prominent ones) ----
    _drawStatue(ctx, w * 0.15, floorY, h * 0.35);
    _drawStatue(ctx, w * 0.85, floorY, h * 0.35);

    // ---- Plants and vines ----
    // Hanging vines from arches
    ctx.strokeStyle = 'rgba(10, 107, 61, 0.4)';
    ctx.lineWidth = 2;
    for (var vi = 0; vi < 30; vi++) {
      var vx = Math.random() * w;
      var vy = h * 0.1 + Math.random() * h * 0.15;
      var vLen = 20 + Math.random() * 60;
      ctx.beginPath();
      ctx.moveTo(vx, vy);
      ctx.quadraticCurveTo(vx + (Math.random() - 0.5) * 20, vy + vLen / 2, vx + (Math.random() - 0.5) * 10, vy + vLen);
      ctx.stroke();
      // Leaves
      for (var li = 0; li < 3; li++) {
        var ly = vy + (vLen / 4) * (li + 1);
        ctx.fillStyle = pick(['rgba(10,107,61,0.5)', 'rgba(13,138,78,0.4)', 'rgba(16,168,95,0.3)']);
        ctx.beginPath();
        ctx.ellipse(vx + (Math.random() - 0.5) * 8, ly, 4, 2, Math.random() * Math.PI, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // Potted plants at floor level
    var plantPositions = [w * 0.08, w * 0.3, w * 0.5, w * 0.7, w * 0.92];
    plantPositions.forEach(function(px) {
      // Pot
      ctx.fillStyle = '#6a5040';
      ctx.fillRect(px - 8, floorY - 16, 16, 16);
      ctx.fillStyle = '#7a6050';
      ctx.fillRect(px - 10, floorY - 18, 20, 4);
      // Bush
      for (var bi = 0; bi < 5; bi++) {
        ctx.fillStyle = pick(['rgba(10,107,61,0.7)', 'rgba(13,138,78,0.6)', 'rgba(16,168,95,0.5)']);
        ctx.beginPath();
        ctx.ellipse(px + (Math.random() - 0.5) * 16, floorY - 20 - Math.random() * 18, 8, 6, 0, 0, Math.PI * 2);
        ctx.fill();
      }
    });

    // ---- Ambient lighting ----
    // Pink/purple light pools
    ctx.globalCompositeOperation = 'screen';
    ctx.globalAlpha = 0.04;

    var radGrad1 = ctx.createRadialGradient(w * 0.2, h * 0.5, 10, w * 0.2, h * 0.5, w * 0.3);
    radGrad1.addColorStop(0, '#ff71ce');
    radGrad1.addColorStop(1, 'transparent');
    ctx.fillStyle = radGrad1;
    ctx.fillRect(0, 0, w, h);

    var radGrad2 = ctx.createRadialGradient(w * 0.8, h * 0.5, 10, w * 0.8, h * 0.5, w * 0.3);
    radGrad2.addColorStop(0, '#b967ff');
    radGrad2.addColorStop(1, 'transparent');
    ctx.fillStyle = radGrad2;
    ctx.fillRect(0, 0, w, h);

    var radGrad3 = ctx.createRadialGradient(w * 0.5, h * 0.3, 10, w * 0.5, h * 0.3, w * 0.25);
    radGrad3.addColorStop(0, '#01cdfe');
    radGrad3.addColorStop(1, 'transparent');
    ctx.fillStyle = radGrad3;
    ctx.fillRect(0, 0, w, h);

    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;

    // Subtle scanlines
    ctx.fillStyle = 'rgba(0,0,0,0.03)';
    for (var sl = 0; sl < h; sl += 3) {
      ctx.fillRect(0, sl, w, 1);
    }

    return c;
  }

  function _drawColumn(ctx, x, top, bottom) {
    var colW = 12;
    var colH = bottom - top;
    // Base
    ctx.fillStyle = 'rgba(200, 190, 180, 0.12)';
    ctx.fillRect(x - 2, bottom - 14, colW + 4, 14);
    // Shaft
    var colGrad = ctx.createLinearGradient(x, 0, x + colW, 0);
    colGrad.addColorStop(0, 'rgba(160, 150, 140, 0.1)');
    colGrad.addColorStop(0.3, 'rgba(200, 190, 180, 0.15)');
    colGrad.addColorStop(0.7, 'rgba(180, 170, 160, 0.12)');
    colGrad.addColorStop(1, 'rgba(140, 130, 120, 0.08)');
    ctx.fillStyle = colGrad;
    ctx.fillRect(x, top + 12, colW, colH - 26);
    // Capital (top)
    ctx.fillStyle = 'rgba(200, 190, 180, 0.14)';
    ctx.fillRect(x - 3, top, colW + 6, 12);
    // Fluting lines
    ctx.strokeStyle = 'rgba(255,255,255,0.04)';
    ctx.lineWidth = 1;
    for (var fl = 2; fl < colW; fl += 3) {
      ctx.beginPath();
      ctx.moveTo(x + fl, top + 12);
      ctx.lineTo(x + fl, bottom - 14);
      ctx.stroke();
    }
  }

  function _drawStatue(ctx, cx, floorY, statueH) {
    // Pedestal
    ctx.fillStyle = 'rgba(180, 170, 160, 0.12)';
    ctx.fillRect(cx - 14, floorY - 20, 28, 20);
    ctx.fillStyle = 'rgba(200, 190, 180, 0.1)';
    ctx.fillRect(cx - 16, floorY - 22, 32, 4);

    var baseY = floorY - 22;

    // Body — simplified classical form
    ctx.fillStyle = 'rgba(200, 195, 190, 0.12)';
    // Torso
    ctx.beginPath();
    ctx.moveTo(cx - 10, baseY);
    ctx.lineTo(cx - 8, baseY - statueH * 0.6);
    ctx.lineTo(cx + 8, baseY - statueH * 0.6);
    ctx.lineTo(cx + 10, baseY);
    ctx.fill();
    // Head
    ctx.beginPath();
    ctx.arc(cx, baseY - statueH * 0.72, 7, 0, Math.PI * 2);
    ctx.fill();
    // Arms
    ctx.fillStyle = 'rgba(190, 185, 180, 0.1)';
    ctx.fillRect(cx - 16, baseY - statueH * 0.55, 6, statueH * 0.25);
    ctx.fillRect(cx + 10, baseY - statueH * 0.55, 6, statueH * 0.25);

    // Subtle glow behind statue
    ctx.globalAlpha = 0.03;
    var statGlow = ctx.createRadialGradient(cx, baseY - statueH * 0.4, 5, cx, baseY - statueH * 0.4, statueH * 0.6);
    statGlow.addColorStop(0, '#b967ff');
    statGlow.addColorStop(1, 'transparent');
    ctx.fillStyle = statGlow;
    ctx.fillRect(cx - statueH, baseY - statueH, statueH * 2, statueH);
    ctx.globalAlpha = 1;
  }

  // ---- Additional Background Generators ----

  function genBg_neonArcade(width, height) {
    var c = createCanvas(width, height);
    var ctx = c.getContext('2d');
    var w = width, h = height;

    // Dark base
    ctx.fillStyle = '#06060e';
    ctx.fillRect(0, 0, w, h);

    // Perspective grid floor
    var floorY = h * 0.55;
    var vanishX = w / 2;
    var vanishY = h * 0.25;

    // Horizontal grid lines
    ctx.strokeStyle = 'rgba(185, 103, 255, 0.2)';
    ctx.lineWidth = 1;
    for (var gy = floorY; gy < h; gy += 18) {
      ctx.beginPath();
      ctx.moveTo(0, gy);
      ctx.lineTo(w, gy);
      ctx.stroke();
      ctx.strokeStyle = 'rgba(185, 103, 255, ' + (0.05 + (gy - floorY) / h * 0.2) + ')';
    }

    // Vertical grid lines converging to vanishing point
    ctx.strokeStyle = 'rgba(1, 205, 254, 0.15)';
    for (var gx = -w; gx < w * 2; gx += 40) {
      ctx.beginPath();
      ctx.moveTo(gx, h);
      ctx.lineTo(vanishX, vanishY);
      ctx.stroke();
    }

    // Horizon glow
    var horizGlow = ctx.createRadialGradient(vanishX, vanishY, 10, vanishX, vanishY, w * 0.5);
    horizGlow.addColorStop(0, 'rgba(255, 113, 206, 0.15)');
    horizGlow.addColorStop(0.5, 'rgba(185, 103, 255, 0.05)');
    horizGlow.addColorStop(1, 'transparent');
    ctx.fillStyle = horizGlow;
    ctx.fillRect(0, 0, w, h);

    // Arcade cabinet silhouettes
    var cabinetPositions = [w * 0.1, w * 0.25, w * 0.42, w * 0.58, w * 0.75, w * 0.9];
    cabinetPositions.forEach(function(cx) {
      var cabH = 80 + Math.random() * 30;
      var cabW = 30 + Math.random() * 10;
      var cabY = floorY - cabH + 10;
      // Cabinet body
      ctx.fillStyle = 'rgba(20, 15, 30, 0.9)';
      ctx.fillRect(cx - cabW / 2, cabY, cabW, cabH);
      // Screen glow
      var screenCol = pick([PALETTE.neonPink, PALETTE.neonCyan, PALETTE.neonPurple, PALETTE.neonGreen]);
      ctx.fillStyle = screenCol + '30';
      ctx.fillRect(cx - cabW / 2 + 4, cabY + 8, cabW - 8, cabH * 0.35);
      ctx.fillStyle = screenCol + '15';
      ctx.fillRect(cx - cabW / 2 - 6, cabY + 4, cabW + 12, cabH * 0.4);
    });

    // Floating neon text fragments
    ctx.font = '6px "Press Start 2P", monospace';
    ctx.globalAlpha = 0.08;
    ['HIGH SCORE', 'INSERT COIN', 'PLAYER 1', 'GAME OVER', 'LEVEL UP'].forEach(function(txt, i) {
      ctx.fillStyle = pick([PALETTE.neonPink, PALETTE.neonCyan, PALETTE.neonPurple]);
      ctx.fillText(txt, w * 0.1 + i * w * 0.18, h * 0.15 + Math.sin(i) * 20);
    });
    ctx.globalAlpha = 1;

    // Scanlines
    ctx.fillStyle = 'rgba(0,0,0,0.04)';
    for (var sl = 0; sl < h; sl += 2) ctx.fillRect(0, sl, w, 1);
    return c;
  }

  function genBg_botanicalGarden(width, height) {
    var c = createCanvas(width, height);
    var ctx = c.getContext('2d');
    var w = width, h = height;

    // Sky gradient — dusk
    var skyGrad = ctx.createLinearGradient(0, 0, 0, h * 0.4);
    skyGrad.addColorStop(0, '#0a1628');
    skyGrad.addColorStop(1, '#162040');
    ctx.fillStyle = skyGrad;
    ctx.fillRect(0, 0, w, h * 0.4);

    // Glass greenhouse ceiling
    ctx.strokeStyle = 'rgba(255,255,255,0.06)';
    ctx.lineWidth = 1;
    for (var ax = 0; ax < w; ax += 60) {
      ctx.beginPath();
      ctx.moveTo(ax, 0);
      ctx.quadraticCurveTo(ax + 30, h * 0.15, ax + 60, 0);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(ax, 0);
      ctx.lineTo(ax, h * 0.35);
      ctx.stroke();
    }

    // Back wall
    ctx.fillStyle = '#0e1a28';
    ctx.fillRect(0, h * 0.25, w, h * 0.75);

    // Stone path floor
    var floorY = h * 0.68;
    ctx.fillStyle = '#1a1a28';
    ctx.fillRect(0, floorY, w, h - floorY);
    // Flagstones
    ctx.strokeStyle = 'rgba(255,255,255,0.03)';
    for (var fx = 0; fx < w; fx += 50) {
      for (var fy = floorY; fy < h; fy += 25) {
        ctx.strokeRect(fx + (fy % 50 === 0 ? 0 : 25), fy, 50, 25);
      }
    }

    // Large plants and ferns
    for (var pi = 0; pi < 40; pi++) {
      var px = Math.random() * w;
      var py = h * 0.3 + Math.random() * (floorY - h * 0.3);
      var size = 10 + Math.random() * 25;
      ctx.fillStyle = pick(['rgba(10,107,61,0.4)', 'rgba(13,138,78,0.3)', 'rgba(16,168,95,0.25)',
                            'rgba(5,100,50,0.35)', 'rgba(20,120,60,0.3)']);
      ctx.beginPath();
      ctx.ellipse(px, py, size, size * 0.6, Math.random() * Math.PI, 0, Math.PI * 2);
      ctx.fill();
    }

    // Hanging plants from ceiling
    for (var hi = 0; hi < 15; hi++) {
      var hx = Math.random() * w;
      var vineLen = 40 + Math.random() * 80;
      ctx.strokeStyle = 'rgba(10,107,61,0.4)';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(hx, 0);
      ctx.quadraticCurveTo(hx + (Math.random() - 0.5) * 30, vineLen / 2, hx + (Math.random() - 0.5) * 15, vineLen);
      ctx.stroke();
      // Leaf clusters
      for (var lf = 0; lf < 4; lf++) {
        ctx.fillStyle = pick(['rgba(10,107,61,0.5)', 'rgba(16,168,95,0.4)']);
        ctx.beginPath();
        ctx.ellipse(hx + (Math.random() - 0.5) * 10, vineLen * (lf + 1) / 5, 5, 3, Math.random() * Math.PI, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // Floor plants in pots
    for (var fp = 0; fp < 6; fp++) {
      var fpx = w * 0.08 + fp * w * 0.17;
      ctx.fillStyle = '#5a4030';
      ctx.fillRect(fpx - 10, floorY - 14, 20, 14);
      for (var fb = 0; fb < 6; fb++) {
        ctx.fillStyle = pick(['rgba(10,107,61,0.6)', 'rgba(13,138,78,0.5)', 'rgba(16,168,95,0.4)']);
        ctx.beginPath();
        ctx.ellipse(fpx + (Math.random() - 0.5) * 18, floorY - 16 - Math.random() * 30, 10, 7, 0, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // Water feature — small pond
    ctx.fillStyle = 'rgba(1, 205, 254, 0.08)';
    ctx.beginPath();
    ctx.ellipse(w / 2, floorY + (h - floorY) * 0.5, 80, 20, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = 'rgba(1, 205, 254, 0.15)';
    ctx.beginPath();
    ctx.ellipse(w / 2, floorY + (h - floorY) * 0.5, 60, 14, 0, 0, Math.PI * 2);
    ctx.fill();

    // Soft ambient light
    ctx.globalCompositeOperation = 'screen';
    ctx.globalAlpha = 0.03;
    var ambGlow = ctx.createRadialGradient(w / 2, h * 0.4, 10, w / 2, h * 0.4, w * 0.4);
    ambGlow.addColorStop(0, '#05ffa1');
    ambGlow.addColorStop(1, 'transparent');
    ctx.fillStyle = ambGlow;
    ctx.fillRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;

    ctx.fillStyle = 'rgba(0,0,0,0.03)';
    for (var sl = 0; sl < h; sl += 3) ctx.fillRect(0, sl, w, 1);
    return c;
  }

  function genBg_marbleGallery(width, height) {
    var c = createCanvas(width, height);
    var ctx = c.getContext('2d');
    var w = width, h = height;

    // Ceiling
    ctx.fillStyle = '#1a1520';
    ctx.fillRect(0, 0, w, h * 0.2);

    // Wall — marble
    var wallGrad = ctx.createLinearGradient(0, h * 0.15, 0, h * 0.7);
    wallGrad.addColorStop(0, '#2a2535');
    wallGrad.addColorStop(1, '#1a1525');
    ctx.fillStyle = wallGrad;
    ctx.fillRect(0, h * 0.15, w, h * 0.55);

    // Marble veins on wall
    ctx.globalAlpha = 0.04;
    for (var vi = 0; vi < 500; vi++) {
      ctx.fillStyle = pick(['#d4c5b0', '#c9b99a', '#a0a0b0']);
      ctx.fillRect(Math.random() * w, h * 0.15 + Math.random() * h * 0.55, 1 + Math.random() * 4, 1);
    }
    ctx.globalAlpha = 1;

    // Floor — polished dark marble
    var floorY = h * 0.7;
    ctx.fillStyle = '#0e0a14';
    ctx.fillRect(0, floorY, w, h - floorY);
    // Reflective sheen
    ctx.fillStyle = 'rgba(255,255,255,0.02)';
    ctx.fillRect(0, floorY, w, 3);

    // Columns
    var colSpacing = w / 6;
    for (var ci = 1; ci <= 5; ci++) {
      _drawColumn(ctx, ci * colSpacing - 6, h * 0.12, floorY);
    }

    // Picture frames on wall
    var frameColors = [PALETTE.neonPink, PALETTE.neonCyan, PALETTE.neonPurple, PALETTE.neonGreen];
    for (var fi = 0; fi < 4; fi++) {
      var fx = w * 0.15 + fi * w * 0.2;
      var fy = h * 0.28;
      var fw = 60;
      var fh = 80;
      // Frame
      ctx.strokeStyle = 'rgba(212, 175, 55, 0.2)';
      ctx.lineWidth = 3;
      ctx.strokeRect(fx, fy, fw, fh);
      // "Painting" — colored glow
      ctx.fillStyle = frameColors[fi] + '10';
      ctx.fillRect(fx + 3, fy + 3, fw - 6, fh - 6);
      // Spotlight from above
      ctx.fillStyle = frameColors[fi] + '08';
      ctx.beginPath();
      ctx.moveTo(fx + fw / 2 - 5, h * 0.15);
      ctx.lineTo(fx - 10, fy + fh + 10);
      ctx.lineTo(fx + fw + 10, fy + fh + 10);
      ctx.fill();
    }

    // Pedestals with busts
    [w * 0.12, w * 0.88].forEach(function(px) {
      ctx.fillStyle = 'rgba(180, 170, 160, 0.1)';
      ctx.fillRect(px - 12, floorY - 40, 24, 40);
      ctx.fillRect(px - 14, floorY - 42, 28, 4);
      // Bust silhouette
      ctx.fillStyle = 'rgba(200, 195, 190, 0.1)';
      ctx.beginPath();
      ctx.arc(px, floorY - 56, 8, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillRect(px - 6, floorY - 50, 12, 10);
    });

    // Ambient light
    ctx.globalCompositeOperation = 'screen';
    ctx.globalAlpha = 0.03;
    var galGlow = ctx.createRadialGradient(w / 2, h * 0.4, 10, w / 2, h * 0.4, w * 0.35);
    galGlow.addColorStop(0, '#b967ff');
    galGlow.addColorStop(1, 'transparent');
    ctx.fillStyle = galGlow;
    ctx.fillRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;

    ctx.fillStyle = 'rgba(0,0,0,0.03)';
    for (var sl = 0; sl < h; sl += 3) ctx.fillRect(0, sl, w, 1);
    return c;
  }

  var BG_GENERATORS = {
    'roman-grotto': genGrottoBackground,
    'neon-arcade': genBg_neonArcade,
    'botanical-garden': genBg_botanicalGarden,
    'marble-gallery': genBg_marbleGallery
  };

  function genShopBackground(preset, width, height) {
    var gen = BG_GENERATORS[preset] || genGrottoBackground;
    return gen(width || 1200, height || 800);
  }

  return {
    TILE: TILE,
    SPRITE_W: SPRITE_W,
    SPRITE_H: SPRITE_H,
    PALETTE: PALETTE,
    TILE_GENERATORS: TILE_GENERATORS,
    genPlayerSprite: genPlayerSprite,
    genFloorTile: genFloorTile,
    genShopWall: genShopWall,
    genShopDoor: genShopDoor,
    genEscalator: genEscalator,
    genSign: genSign,
    genStoreFront: genStoreFront,
    genPalmTree: genPalmTree,
    genFountain: genFountain,
    genBench: genBench,
    genPlanter: genPlanter,
    genShopBackground: genShopBackground,
    loadIntoPhaser: loadIntoPhaser
  };
})();
